import { Trans } from '@lingui/react/macro';
import { NoddiBasicCard } from 'noddi-ui-web';

import { ContactUs } from '@components/Common/ContactUs';

export const NoCoupons = () => (
  <NoddiBasicCard className='flex flex-col gap-5'>
    <p className='text-xl font-semibold'>
      {/* eslint-disable-next-line noddi/no-emoji-in-ui -- deliberate emoji in customer-facing copy: it carries the tone of the message, it is not a status a NoddiIcon could show */}
      <Trans>No discounts found</Trans> 😭
    </p>

    <ContactUs />
  </NoddiBasicCard>
);
